import { Box, Button } from "@mui/material";
import { isAxiosError } from "axios";
import { useState } from "react";
import { isRouteErrorResponse, useAsyncError, useRouteError } from "react-router-dom";

export default function ErrorBoundary() {
    const routeError = useRouteError();
    const axiosError = useAsyncError();
    const [copiedToClipboard, setCopiedToClipboard] = useState(false);

    const handleButtonClick = (error) => {
        setCopiedToClipboard(true);
        const data = {};
        data.location = window.location.href;
        data.error = error.statusText || error.message || error.response;

        navigator.clipboard.writeText(JSON.stringify(data));
    }

    return (
        <Box className='flex abs-center center-text fullwh'>
            {routeError && (
                <Box>

                    <h1>Сталась помилка!</h1>
                    <i>{routeError && (routeError.statusText || routeError.message)}</i>
                    <h2>{routeError.status ?? routeError.response?.status}</h2>
                    <p>{routeError.statusText ?? routeError.response?.statusText}</p>
                    {routeError.data?.message && <p>{routeError.data.message}</p>}
                    {routeError.response?.message && <p>{routeError.response.message}</p>}
                    {routeError.response?.data && <p>{JSON.stringify(routeError.response.data)}</p>}
                    <Box>
                        <Button onClick={() => handleButtonClick(routeError)}
                            variant='contained'
                        >
                            {copiedToClipboard ? (
                                "Скопійовано!"
                            ) : (
                                "Скопіювати текст помилки до буферу обміну"
                            )}
                        </Button>
                    </Box>
                </Box>
            )}
            {axiosError && (
                <Box>
                    <h1>Сталась помилка!</h1>
                    <h2>{axiosError.status ?? axiosError.response?.status}</h2>
                    <p>{axiosError.statusText ?? axiosError.response?.statusText}</p>
                    {axiosError.data?.message && <p>{axiosError.data.message}</p>}
                    {axiosError.response?.message && <p>{axiosError.response.message}</p>}
                    {axiosError.response?.data && <p>{JSON.stringify(axiosError.response.data)}</p>}
                    <Box>
                        <Button onClick={() => handleButtonClick(axiosError)}
                            variant='contained'
                        >
                            {copiedToClipboard ? (
                                "Скопійовано!"
                            ) : (
                                "Скопіювати текст помилки до буферу обміну"
                            )}
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    )
}